import { supabase } from '@/lib/supabase';

export async function saveFCMToken(token) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return;

  await supabase.from('fcm_tokens').upsert({
    user_id: user.id,
    token,
    is_active: true,
    device_info: { userAgent: navigator.userAgent, timestamp: new Date().toISOString() }
  }, { onConflict: 'token' });
}
